import { render } from "./DatastoreQueryBuilderAreas.vue?vue&type=template&id=da72a462&scoped=true"
import script from "./DatastoreQueryBuilderAreas.vue?vue&type=script&lang=js"
export * from "./DatastoreQueryBuilderAreas.vue?vue&type=script&lang=js"

import "./DatastoreQueryBuilderAreas.vue?vue&type=style&index=0&id=da72a462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da72a462"]])

export default __exports__